import {
  TooltipContainer,
  TooltipContainerProps,
} from '@terminal/components/tooltip-container/TooltipContainer';
import { cloneElement, ReactElement, useEffect, useRef, useState } from 'react';

interface EllipsisDetectorProps extends TooltipContainerProps {
  children: ReactElement<any>;
  vertical?: boolean;
}

export const EllipsisDetector = ({
  children,
  vertical = false,
  ...tooltipProps
}: EllipsisDetectorProps) => {
  const ref = useRef<HTMLElement>(null);
  const [ellipsisActive, setEllipsisActive] = useState(false);

  const isEllipsisActive = (el: HTMLElement) => {
    return vertical
      ? el.offsetHeight < el.scrollHeight
      : el.offsetWidth < el.scrollWidth;
  };

  useEffect(() => {
    if (ref.current) {
      setEllipsisActive(isEllipsisActive(ref.current));
    }
  }, [ref.current]);

  return (
    <>
      {!ellipsisActive ? (
        cloneElement(children, { ref })
      ) : (
        <TooltipContainer {...tooltipProps}>
          {cloneElement(children)}
        </TooltipContainer>
      )}
    </>
  );
};
